export const sleep = async (ms) => new Promise(resolve => setTimeout(resolve, ms));


// WEBPACK FOOTER //
// ./src/common/sleep.js